// extracted by mini-css-extract-plugin
export default {"container":"Ordered_Status_container__zT8lk","image":"Ordered_Status_image__DZfxS"};